import { ApiHelper, useQuery } from "../../api/index";
import { ProjectGovernorCheck } from "./types";
import { Spinner } from "@altimateai/lego";
import { useEffect } from "react";
import ProjectGovernorForm from "./ProjectGovernorForm";
import { Stack } from "@altimateai/lego";
import ProjectGovernanceCheck from "./ProjectGovernanceCheck";
import {
  Button,
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@altimateai/lego";
import { Alert } from "@altimateai/lego";

const ProjectGovernorDisplay = () => {
  const {
    data: checks,
    error,
    loading,
    refetch,
  } = useQuery<ProjectGovernorCheck[]>({
    queryFn: () => ApiHelper.get<ProjectGovernorCheck[]>(`project_governance/checks`),
    enabled: false,
  });

  useEffect(() => {
    refetch();
    // avoid refetching on every render
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return <Spinner />;
  }
  if (error) {
    return <Alert color="danger">Error loading checks: {error.message}</Alert>;
  }

  return (
    <>
      <div>
        <Stack className="al-justify-end">
          <Sheet>
            <SheetTrigger asChild>
              <Button variant="secondary">+ Add new check</Button>
            </SheetTrigger>
            <SheetContent>
              <SheetHeader>
                <SheetTitle>Add new check</SheetTitle>
              </SheetHeader>
              <ProjectGovernorForm
                onClose={() => {
                  refetch();
                }}
              />
            </SheetContent>
          </Sheet>
        </Stack>
        <Stack direction="column" className="al-mt-2">
          {checks?.length ? (
            checks.map(check => {
              return <ProjectGovernanceCheck key={check.id} check={check} refetch={refetch} />;
            })
          ) : (
            <div>No checks added yet!</div>
          )}
        </Stack>
      </div>
    </>
  );
};

export default ProjectGovernorDisplay;
